import React from 'react';
const AccountConfig = {
    settings: {
        layout: {}
    },
    routes: [
        {
            path: '/apps/account-limits',
            component: React.lazy(() => import('./AccountLimit'))
        }
    ]
};

export default AccountConfig;
